// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RF-z","twoColumnImage":"SF-z"};